import { Component } from '@angular/core';

@Component({
  selector: 'phc-man-with-dog-image-component',
  templateUrl: './man-with-dog.component.html',
  styleUrls: ['./man-with-dog.component.scss']
})
export class ManWithDogComponent {

  

}
